<script lang="ts">
	import cn from 'classnames';
	import { scooterStorage } from '../../stores/preferences';
	import { detectClickOutside } from '$lib/utils/detectClickOutside';
	import Button from './Button.svelte';
	import { _CategoriesEnum_t } from '$lib/utils/Enums';

	export let data;

	export let isCentered = false;
	export let buttonText = 'Všechny kategorie';
	let showCategories = false;
	let isUsed = false;
	export let categoryType: _CategoriesEnum_t = _CategoriesEnum_t.UNI;

	const toggleCategories = () => {
		showCategories = !showCategories;
	};

	const handleClickOutside = () => {
		showCategories = false;
	};
</script>

<div
	class={cn('relative w-full md:hidden mt-2', $$props.class)}
	use:detectClickOutside
	on:click_outside={handleClickOutside}
>
	<Button
		isSmall
		onClick={toggleCategories}
		id="dropdownCategories"
		data-dropdown-toggle="dropdownCategoriesList"
		class={cn('relative z-50 block xs:w-auto', isCentered ? 'mx-auto' : 'ml-auto')}
		>{buttonText}</Button
	>

	<ul
		id="dropdownCategoriesList"
		class={cn(
			'absolute z-50 grid w-[calc(100vw-theme(space.4))] max-w-[20rem] grid-cols-2 bg-white px-8 py-6 text-left text-black shadow',
			!isCentered ? 'right-0 top-full' : 'left-1/2 -translate-x-1/2',
			showCategories ? 'flex' : 'hidden'
		)}
		aria-labelledby="dropdownCategories"
	>
		{#each data as item}
			<li>
				<a
					target="_self"
					href={categoryType === _CategoriesEnum_t.UNI
						? '/univerzalni-dily/' + item.url
						: '/skutr-' +
							$scooterStorage.url +
							'/' +
							(isUsed ? 'pouzite-dily' : 'nahradni-dily') +
							'/' +
							item.url}
					class="inline-block px-4 py-2"
				>
					{item.name} ({item.amount})
				</a>
			</li>
		{/each}
	</ul>
</div>

{#if showCategories}
	<div class={cn('fixed left-0 top-0 z-40 h-screen w-screen bg-black opacity-40 md:hidden')} />
{/if}
